export default "__VITE_ASSET__B2fw8duP__"